export default {
  "Athens": {
    "lat": 37.9838,
    "lng": 23.7275,
    "country": "GR"
  },
  "Thessaloníki": {
    "lat": 40.6401,
    "lng": 22.9444,
    "country": "GR"
  },
  "Maroúsi": {
    "lat": 38.05,
    "lng": 23.8,
    "country": "GR"
  },
  "Peristéri": {
    "lat": 38.01539,
    "lng": 23.69187,
    "country": "GR"
  },
  "Pátra": {
    "lat": 38.24444,
    "lng": 21.73444,
    "country": "GR"
  },
  "Piraeus": {
    "lat": 37.94203,
    "lng": 23.64619,
    "country": "GR"
  },
  "Níkaia": {
    "lat": 39.56667,
    "lng": 22.46667,
    "country": "GR"
  },
  "Lárisa": {
    "lat": 39.63689,
    "lng": 22.41761,
    "country": "GR"
  },
  "Irákleio": {
    "lat": 38.05282,
    "lng": 23.76523,
    "country": "GR"
  },
  "Ílion": {
    "lat": 38.03333,
    "lng": 23.7,
    "country": "GR"
  },
  "Výronas": {
    "lat": 37.96105,
    "lng": 23.753,
    "country": "GR"
  },
  "Palaió Fáliro": {
    "lat": 37.92812,
    "lng": 23.70105,
    "country": "GR"
  },
  "Glyfáda": {
    "lat": 37.86289,
    "lng": 23.75802,
    "country": "GR"
  },
  "Volos": {
    "lat": 39.36923,
    "lng": 22.94769,
    "country": "GR"
  },
  "Kifisiá": {
    "lat": 38.07438,
    "lng": 23.81106,
    "country": "GR"
  },
  "Khalándrion": {
    "lat": 38.02369,
    "lng": 23.80068,
    "country": "GR"
  },
  "Nicosia": {
    "lat": 35.1856,
    "lng": 33.3823,
    "country": "CY"
  },
  "Larnaca": {
    "lat": 34.918,
    "lng": 33.623,
    "country": "CY"
  },
  "Paphos": {
    "lat": 34.7754,
    "lng": 32.4218,
    "country": "CY"
  },
  "Acharnés": {
    "lat": 38.08333,
    "lng": 23.73333,
    "country": "GR"
  },
  "Kalamata": {
    "lat": 37.03913,
    "lng": 22.11265,
    "country": "GR"
  },
  "Ilioúpoli": {
    "lat": 37.93149,
    "lng": 23.76779,
    "country": "GR"
  },
  "Zográfos": {
    "lat": 37.97574,
    "lng": 23.76911,
    "country": "GR"
  },
  "Chaniá": {
    "lat": 35.51124,
    "lng": 24.02921,
    "country": "GR"
  },
  "Chalkída": {
    "lat": 38.46354,
    "lng": 23.60284,
    "country": "GR"
  },
  "Corfu": {
    "lat": 39.62441,
    "lng": 19.92016,
    "country": "GR"
  },
  "Néa Smýrni": {
    "lat": 37.94504,
    "lng": 23.71416,
    "country": "GR"
  },
  "Agios Dimitrios": {
    "lat": 37.93333,
    "lng": 23.73333,
    "country": "GR"
  },
  "Kozáni": {
    "lat": 40.30069,
    "lng": 21.78896,
    "country": "GR"
  },
  "Tríkala": {
    "lat": 39.55493,
    "lng": 21.76837,
    "country": "GR"
  },
  "Kavála": {
    "lat": 40.93959,
    "lng": 24.40687,
    "country": "GR"
  },
  "Irákleion": {
    "lat": 35.32787,
    "lng": 25.14341,
    "country": "GR"
  },
  "Galátsi": {
    "lat": 38.01667,
    "lng": 23.75,
    "country": "GR"
  },
  "Ekáli": {
    "lat": 38.11035,
    "lng": 23.83505,
    "country": "GR"
  },
  "Petroúpolis": {
    "lat": 38.04187,
    "lng": 23.68494,
    "country": "GR"
  },
  "Sérres": {
    "lat": 41.09011,
    "lng": 23.54127,
    "country": "GR"
  },
  "Néa Filadélfeia": {
    "lat": 38.03491,
    "lng": 23.73811,
    "country": "GR"
  },
  "Kateríni": {
    "lat": 40.26956,
    "lng": 22.50608,
    "country": "GR"
  },
  "Kórinthos": {
    "lat": 37.94007,
    "lng": 22.9513,
    "country": "GR"
  },
  "Chaïdári": {
    "lat": 38.01135,
    "lng": 23.66597,
    "country": "GR"
  },
  "Voúla": {
    "lat": 37.84221,
    "lng": 23.77651,
    "country": "GR"
  },
  "Moskháton": {
    "lat": 37.94789,
    "lng": 23.6788,
    "country": "GR"
  },
  "Kardítsa": {
    "lat": 39.36485,
    "lng": 21.92191,
    "country": "GR"
  },
  "Giannitsá": {
    "lat": 40.79194,
    "lng": 22.4075,
    "country": "GR"
  },
  "Gérakas": {
    "lat": 38.02277,
    "lng": 23.8576,
    "country": "GR"
  },
  "Rethymno": {
    "lat": 35.36555,
    "lng": 24.48232,
    "country": "GR"
  },
  "Dhafní": {
    "lat": 37.95002,
    "lng": 23.73437,
    "country": "GR"
  },
  "Kallithéa": {
    "lat": 37.95,
    "lng": 23.7,
    "country": "GR"
  },
  "Pýrgos": {
    "lat": 34.74167,
    "lng": 33.18333,
    "country": "GR"
  },
  "Keratsíni": {
    "lat": 37.9625,
    "lng": 23.61972,
    "country": "GR"
  },
  "Livadeiá": {
    "lat": 38.43616,
    "lng": 22.87665,
    "country": "GR"
  },
  "Véroia": {
    "lat": 40.52437,
    "lng": 22.20242,
    "country": "GR"
  },
  "Melíssia": {
    "lat": 38.05,
    "lng": 23.83333,
    "country": "GR"
  },
  "Mytilene": {
    "lat": 39.10772,
    "lng": 26.55529,
    "country": "GR"
  },
  "Trípoli": {
    "lat": 37.50889,
    "lng": 22.37944,
    "country": "GR"
  },
  "Dráma": {
    "lat": 41.15283,
    "lng": 24.1473,
    "country": "GR"
  },
  "Xánthi": {
    "lat": 41.13488,
    "lng": 24.888,
    "country": "GR"
  },
  "Préveza": {
    "lat": 38.95617,
    "lng": 20.7505,
    "country": "GR"
  },
  "Vrilissia": {
    "lat": 38.03381,
    "lng": 23.82962,
    "country": "GR"
  },
  "Komotiní": {
    "lat": 41.11917,
    "lng": 25.40535,
    "country": "GR"
  },
  "Ródos": {
    "lat": 36.43556,
    "lng": 28.22199,
    "country": "GR"
  },
  "Álimos": {
    "lat": 37.91033,
    "lng": 23.72361,
    "country": "GR"
  },
  "Néa Mákri": {
    "lat": 38.08733,
    "lng": 23.97642,
    "country": "GR"
  },
  "Agía Paraskeví": {
    "lat": 39.24792,
    "lng": 26.27178,
    "country": "GR"
  },
  "Argostólion": {
    "lat": 38.18109,
    "lng": 20.48903,
    "country": "GR"
  },
  "Artémida": {
    "lat": 37.96727,
    "lng": 23.99684,
    "country": "GR"
  },
  "Árgos": {
    "lat": 37.63333,
    "lng": 22.73333,
    "country": "GR"
  },
  "Péfki": {
    "lat": 38.06019,
    "lng": 23.79264,
    "country": "GR"
  },
  "GR": {
    "lat": 39.0742,
    "lng": 21.8243,
    "country": "GR"
  },
  "London": {
    "lat": 51.5072,
    "lng": -0.1276,
    "country": "UK"
  },
  "Néa Ionía": {
    "lat": 38.0357,
    "lng": 23.75733,
    "country": "GR"
  },
  "Néo Psychikó": {
    "lat": 38.00624,
    "lng": 23.78373,
    "country": "GR"
  },
  "Korydallós": {
    "lat": 37.98468,
    "lng": 23.64711,
    "country": "GR"
  },
  "Chios": {
    "lat": 38.36875,
    "lng": 26.13718,
    "country": "GR"
  },
  "Aigáleo": {
    "lat": 37.98333,
    "lng": 23.68333,
    "country": "GR"
  },
  "Paianía": {
    "lat": 37.95527,
    "lng": 23.85443,
    "country": "GR"
  },
  "Psychikó": {
    "lat": 38.01324,
    "lng": 23.77223,
    "country": "GR"
  },
  "Thívai": {
    "lat": 38.325,
    "lng": 23.31889,
    "country": "GR"
  },
  "Argyroúpoli": {
    "lat": 37.90594,
    "lng": 23.75035,
    "country": "GR"
  },
  "Vári": {
    "lat": 37.8332,
    "lng": 23.80311,
    "country": "GR"
  },
  "Mégara": {
    "lat": 37.99471,
    "lng": 23.34324,
    "country": "GR"
  },
  "Ioánnina": {
    "lat": 39.66486,
    "lng": 20.85189,
    "country": "GR"
  },
  "Pallíni": {
    "lat": 38.00514,
    "lng": 23.88302,
    "country": "GR"
  },
  "Koropí": {
    "lat": 37.89886,
    "lng": 23.87181,
    "country": "GR"
  },
  "Árta": {
    "lat": 11.52639,
    "lng": 42.85194,
    "country": "DJ"
  },
  "Cholargós": {
    "lat": 38.0,
    "lng": 23.8,
    "country": "GR"
  },
  "Neapoli": {
    "lat": 35.25627,
    "lng": 25.60415,
    "country": "GR"
  },
  "Flórina": {
    "lat": 40.78197,
    "lng": 21.40981,
    "country": "GR"
  },
  "Agrínio": {
    "lat": 38.62139,
    "lng": 21.40778,
    "country": "GR"
  },
  "Asprópyrgos": {
    "lat": 38.06134,
    "lng": 23.58971,
    "country": "GR"
  },
  "Kamaterón": {
    "lat": 38.05586,
    "lng": 23.70515,
    "country": "GR"
  },
  "Filothéi": {
    "lat": 38.02524,
    "lng": 23.78257,
    "country": "GR"
  },
  "New York City": {
    "lat": 40.71427,
    "lng": -74.00597,
    "country": "US"
  },
  "Ágios Matthaíos": {
    "lat": 39.49506,
    "lng": 19.87336,
    "country": "GR"
  },
  "Brussels": {
    "lat": 50.85045,
    "lng": 4.34878,
    "country": "BE"
  },
  "Salamína": {
    "lat": 37.9646,
    "lng": 23.4966,
    "country": "GR"
  },
  "Ágioi Anárgyroi": {
    "lat": 38.03013,
    "lng": 23.72379,
    "country": "GR"
  },
  "Ptolemaḯda": {
    "lat": 40.51472,
    "lng": 21.67861,
    "country": "GR"
  },
  "Munich": {
    "lat": 48.13743,
    "lng": 11.57549,
    "country": "DE"
  },
  "Vienna": {
    "lat": 48.20849,
    "lng": 16.37208,
    "country": "AT"
  },
  "Frankfurt am Main": {
    "lat": 50.11552,
    "lng": 8.68417,
    "country": "DE"
  },
  "Aígio": {
    "lat": 38.24861,
    "lng": 22.08194,
    "country": "GR"
  },
  "Áyioi Apóstoloi": {
    "lat": 38.29169,
    "lng": 23.91011,
    "country": "GR"
  },
  "Ellinikó": {
    "lat": 37.89013,
    "lng": 23.74406,
    "country": "GR"
  },
  "Kastoria": {
    "lat": 40.52165,
    "lng": 21.26341,
    "country": "GR"
  },
  "Berlin": {
    "lat": 52.52437,
    "lng": 13.41053,
    "country": "DE"
  },
  "Metamórfosi": {
    "lat": 38.06576,
    "lng": 23.76356,
    "country": "GR"
  },
  "Panórama": {
    "lat": -34.9908,
    "lng": 138.59948,
    "country": "AU"
  },
  "Néa Erythraía": {
    "lat": 38.0927,
    "lng": 23.82223,
    "country": "GR"
  },
  "Amsterdam": {
    "lat": 52.37403,
    "lng": 4.88969,
    "country": "NL"
  },
  "Köln": {
    "lat": 50.93333,
    "lng": 6.95,
    "country": "DE"
  },
  "Paris": {
    "lat": 48.8566,
    "lng": 2.3522,
    "country": "France"
  },
  "Ágios Stéfanos": {
    "lat": 38.14657,
    "lng": 23.85608,
    "country": "GR"
  },
  "Kilkís": {
    "lat": 40.99302,
    "lng": 22.87433,
    "country": "GR"
  },
  "Limassol": {
    "lat": 34.68406,
    "lng": 33.03794,
    "country": "CY"
  },
  "Zürich": {
    "lat": 47.36667,
    "lng": 8.55,
    "country": "CH"
  },
  "Limín Mesoyaías": {
    "lat": 37.89108,
    "lng": 24.00307,
    "country": "GR"
  },
  "Kos": {
    "lat": 36.89295,
    "lng": 27.28768,
    "country": "GR"
  },
  "Dhrosiá": {
    "lat": 38.48413,
    "lng": 23.54774,
    "country": "GR"
  },
  "Thérmi": {
    "lat": 40.54712,
    "lng": 23.01967,
    "country": "GR"
  },
  "Ermoúpolis": {
    "lat": 37.44466,
    "lng": 24.9429,
    "country": "GR"
  },
  "Milan": {
    "lat": 45.4642,
    "lng": 9.19,
    "country": "Italy"
  },
  "Selínia": {
    "lat": 37.9332,
    "lng": 23.53147,
    "country": "GR"
  },
  "Stockholm": {
    "lat": 59.32938,
    "lng": 18.06871,
    "country": "SE"
  },
  "Távros": {
    "lat": 37.97064,
    "lng": 23.69043,
    "country": "GR"
  },
  "Mesolóngi": {
    "lat": 38.37138,
    "lng": 21.43151,
    "country": "GR"
  },
  "Sofia": {
    "lat": 42.69751,
    "lng": 23.32415,
    "country": "BG"
  },
  "Melbourne": {
    "lat": -37.814,
    "lng": 144.96332,
    "country": "AU"
  },
  "Alexandroupoli": {
    "lat": 40.84995,
    "lng": 25.87644,
    "country": "GR"
  },
  "Stuttgart": {
    "lat": 48.78232,
    "lng": 9.17702,
    "country": "DE"
  },
  "Igoumenítsa": {
    "lat": 39.50342,
    "lng": 20.26728,
    "country": "GR"
  },
  "Firá": {
    "lat": 36.42107,
    "lng": 25.43087,
    "country": "GR"
  },
  "Kalývia Thorikoú": {
    "lat": 37.83894,
    "lng": 23.92505,
    "country": "GR"
  },
  "Lykóvrysi": {
    "lat": 38.06933,
    "lng": 23.78223,
    "country": "GR"
  },
  "Plános": {
    "lat": 37.813,
    "lng": 20.844,
    "country": "GR"
  },
  "Oraiókastro": {
    "lat": 40.73083,
    "lng": 22.91722,
    "country": "GR"
  },
  "Rafína": {
    "lat": 38.01812,
    "lng": 24.00599,
    "country": "GR"
  },
  "Bucharest": {
    "lat": 44.43225,
    "lng": 26.10626,
    "country": "RO"
  },
  "Agía Varvára": {
    "lat": 37.98938,
    "lng": 23.66011,
    "country": "GR"
  },
  "Pérama": {
    "lat": 39.69331,
    "lng": 20.84656,
    "country": "GR"
  },
  "Villa Ritz": {
    "lat": 37.9795,
    "lng": 23.7162,
    "country": "GR"
  },
  "Rome": {
    "lat": 41.89193,
    "lng": 12.51133,
    "country": "IT"
  },
  "Gέrakas": {
    "lat": 38.0167,
    "lng": 23.85,
    "country": "GR"
  }
} as const;
